<template>
  <div class="box is-boxed" style="padding: 13px; margin-bottom: 10px;">
    <article class="media" style="margin-bottom: 10px;">
      <figure class="media-left">
        <nuxt-link :to="{name: 'profile-username', params: {username: !isEmpty(post.user) ? post.user.email : ''}}">
          <div class="image is-40x40 is-circle" style="overflow: hidden;">
            <avatar :avatar_url="getPostAvatar(post)"></avatar>
          </div>
        </nuxt-link>
      </figure>
      <div class="media-content title-post">
        <div style="margin-bottom: -5px;">
          <div>
            <strong class="nama-author truncated-text" :data-tooltip="getPostAuthor(post)"><nuxt-link class="has-text-darkblue" :to="{name: 'profile-username', params: {username: !isEmpty(post.user) ? post.user.email : ''}}">{{ getPostAuthor(post) }}</nuxt-link></strong>
            <span class="has-text-grey font-14">
              {{ getActDesc(post) }}

              <span v-if="!isEmpty(post.section)">
                <nuxt-link class="has-text-primary" :to="{ path: `/panel/classes/${group.id}/sections/${post.section.id}` }" v-if="!isEmpty(post.section) && group.type == 'A'">Sesi ke {{ post.section.meet }}</nuxt-link>
                <nuxt-link class="has-text-primary" :to="{ path: `/panel/groups/${group.id}/sections/${post.section.id}` }" v-else-if="!isEmpty(post.section) && group.type != 'A'">Sesi ke {{ post.section.meet }}</nuxt-link>
              </span>
            </span>
          </div>
        </div>
        <small class="date-post font-14 has-text-grey">{{ date_humanize(post.updatedAt) }}</small>
        <br>
      </div>

      <div class="media-right" v-if="!isEmpty(auth) && post.userId == auth.id">
        <div class="columns is-mobile" style="margin-bottom: 0;">
          <div class="column is-narrow">
            <div class="dropdown is-right is-hoverable">
              <div class="dropdown-trigger">
                <a href="" @click.prevent="" class="button is-text hoverable-option has-text-grey" aria-haspopup="true" aria-controls="dropdown-menu">
                  <span class="icon">
                    <b-icon icon="dots-vertical"></b-icon>
                  </span>
                </a>
              </div>
              <div class="dropdown-menu" role="menu">
                <div class="dropdown-content">
                  <a href="#" class="dropdown-item" @click.prevent="edit(post)">
                    <span class="icon"><i class="fas fa-edit"></i></span>
                    <span>Ubah</span>
                  </a>
                  <hr class="dropdown-divider">
                  <a href="#" class="dropdown-item has-text-danger" @click.prevent="deletePost(post.id)">
                    <span class="icon"><i class="fas fa-trash"></i></span>
                    <span>Hapus</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </article>

    <custom-carousel v-if="!isEmpty(post.cover)" style="margin: 0 -13px 12px;" :items="[{type: 'image', link_source: post.cover, link_thumb: post.cover}]"></custom-carousel>

    <h3 v-if="['Z', 'Q'].indexOf(post.type) <= -1" class="post-title" style="margin-bottom: 10px;">
      <a href="" class="has-text-dark" @click.prevent="group.type == 'A' ? toDetailPost(post, 'classes') : toDetailPost(post, 'groups')">{{ post.title }}</a>
    </h3>
    <div v-if="['Z', 'Q'].indexOf(post.type) <= -1" clas="content">
      <pre class="font-secondary font-14" style="background: transparent; padding: 0; white-space: pre-line; margin-bottom: 0;" v-html="is_truncate ? post.cleanDescription.substring(0, truncate_limit) + '...' : post.cleanDescription"></pre>

      <div v-if="!is_truncate">
        <br v-if="post.type == 'G'">
        <p v-if="post.type == 'G'" style="word-break: break-all;"><small>Sumber: <a :href="post.extUrl" target="_blank" rel="noopener" class="has-text-link">{{ post.extUrl }}</a></small></p>
        <br v-if="post.type == 'G'">
      </div>

      <div v-if="!isEmpty(post.cleanDescription) && post.cleanDescription.length > truncate_limit" class="font-14">
        <a v-if="is_truncate" @click.prevent="seeMore(post)" href="" class="has-text-info">Lihat Semua</a>
        <a v-else @click.prevent="is_truncate = true" href="" class="has-text-info">Sembunyikan</a>
      </div>
    </div>

    <div v-if="post.type == 'S' && post.survey !== undefined && post.survey !== null">
      <br>
      <div class="columns is-mobile is-vcentered" style="margin-bottom: 0;" v-for="(choice, key) in post.survey.choices" :key="key">
        <div class="column is-narrow">
          <div class="field">
            <input class="is-checkradio" :id="`c-${choice.id}-${key}`" type="checkbox" :name="`c-${choice.id}-${key}`" :checked="choice.selected" @click.prevent="addChoice(post.survey, choice, key)">
            <label :for="`c-${choice.id}-${key}`" style="padding-left: 0;"></label>
          </div>
        </div>
        <div class="column is-7">
          <div class="progress-wrapper">
            <progress class="progress is-info is-no-margin is-medium" :value="roundNumeric(choice.userCount / group.groupMembersCount * 100)" max="100"></progress>
            <p class="progress-value has-text-white">{{ choice.name }}</p>
          </div>
        </div>
        <div class="column has-text-right">
          <span>
            <p>{{ choice.userCount }}&nbsp;<i class="fas fa-users"></i></p>
          </span>
        </div>
      </div>
    </div>

    <div class="event-detail" v-else-if="post.type == 'E'">
      <div class="columns" style="margin-top: 5px;">
        <div class="column is-4-fullhd is-4-widescreen is-4-desktop is-4-tablet is-12-mobile" style="border-right: 1px solid #E5E5E5;">
          <h3><i class="fa fa-calendar"></i>&nbsp;TANGGAL</h3>
          <p style="font-size: 13px;">{{ post.event ? getFormattedDate(post.event.startAt) : '' }}</p>
        </div>
        <div class="column is-4-fullhd is-4-widescreen is-4-desktop is-4-tablet is-12-mobile" style="border-right: 1px solid #E5E5E5;">
          <div v-if="post.event !== null && post.event.endAt > 0 && post.event.endAt != null">
            <h3><i class="fa fa-calendar"></i>&nbsp;BERAKHIR PADA</h3>
            <p style="font-size: 13px;">{{ post.event ? getFormattedDate(post.event.endAt) : '' }}</p>
          </div>
          <div v-if="post.event == null || post.event.endAt == null || post.event.endAt == 0 || post.event.endAt == -1">
            <h3>SELESAI</h3>
            <p style="font-size: 13px;">Selesai</p>
          </div>
        </div>
        <div class="column is-4-fullhd is-4-widescreen is-4-desktop is-4-tablet is-12-mobile">
          <h3><i class="fa fa-map-marker"></i>&nbsp;TEMPAT</h3>
          <p style="font-size: 13px;">{{ post.event.location }}</p>
        </div>
      </div>
    </div>

    <div v-else-if="!isEmpty(post.quiz) && post.type == 'Z' && !isEmpty(post.section)"
      class="columns is-vcentered box is-bg-info is-gapless is-mobile"
      style="border: none; margin-top:15px; margin-left: -13px; margin-right: -13px; border-radius: 0;"
    >
      <div class="column">
        <span class="tag" v-if="!isEmpty(post.quiz.finishedAt)">
          <vcountdown class="has-text-grey" :finished="post.quiz.finishedAt"></vcountdown>
        </span>
        <span class="tag is-dark is-medium" style="background: transparent; margin-top:2px; padding-left: 0;">{{ post.quiz.questions.length }} Soal</span>
        <h3 class="title is-3 has-text-white font-secondary" style="font-size: 1.5rem; font-weight: 700; line-height: 1.2;">
          <a class="has-text-white" @click.prevent="group.type == 'A' ? toDetailPost(post, 'classes') : toDetailPost(post, 'groups')">{{ post.title }}</a>
        </h3>
      </div>
      <div class="column is-narrow has-text-centered">
        <!-- Teacher -->
        <div v-if="['O', 'A'].indexOf(group.groupMemberRole) > -1">
          <nuxt-link v-if="post.group.type == 'A'" :to="getPostDetailUrl(post)" class="button is-medium is-white is" style="margin-bottom: 10px;">
            <i class="fa fa-list-ol"></i>
          </nuxt-link>
          <nuxt-link v-if="post.group.type != 'A'" :to="getPostDetailUrl(post)" class="button is-medium is-white" style="margin-bottom: 10px;">
            <i class="fa fa-list-ol"></i>
          </nuxt-link>
          <p class="has-text-white">Lihat Hasil</p>
        </div>

        <!-- Student -->
        <div v-else-if="['M'].indexOf(group.groupMemberRole) > -1">
          <div v-if="post.quiz.status == 1">
            <div v-if="!post.quiz.isAnsweredAll">
              <button @click.prevent="startQuiz(post.quiz.id)" class="button is-medium is-white is-boxed-2" style="margin-bottom: 10px;" :class="{'is-loading': loading_start_quiz}">
                <i class="fa fa-play"></i>
              </button>
              <p class="has-text-white">Mulai Quiz</p>
            </div>
            <div v-else>
              <nuxt-link :to="getPostDetailUrl(post)" class="button is-medium is-white is-boxed-2" style="margin-bottom: 10px;">
                <span class="icon"><strong>{{ post.quiz.grade }}</strong></span>
              </nuxt-link>
              <p class="has-text-white">Lihat Detail</p>
            </div>
          </div>
          <div v-else-if="post.quiz.status == 2">
            <nuxt-link :to="getPostDetailUrl(post)" class="button is-medium is-white is-boxed-2" style="margin-bottom: 10px;">
              <span class="icon"><strong>{{ post.quiz.grade }}</strong></span>
            </nuxt-link>
            <p class="has-text-white">Lihat Detail</p>
          </div>
        </div>
      </div>
    </div>

    <div v-else-if="!isEmpty(post.teacherQuestion) && post.type == 'Q'"
      class="columns is-vcentered box is-bg-grey"
      style="border: none; margin-top:15px; margin-left: -13px; margin-right: -13px; border-radius: 0;"
    >
      <div class="column">
        <span class="tag" v-if="!isEmpty(post.teacherQuestion.dueDate)">
          <vcountdown v-if="post.teacherQuestion.status == 'O'" class="has-text-grey" :finished="post.teacherQuestion.dueDate"></vcountdown>
          <span v-if="post.teacherQuestion.status != 'O'" class="has-text-grey">SELESAI</span>
        </span>
        <h3 class="title is-3 has-text-white font-secondary" style="font-size: 1.5rem; font-weight: 700; line-height: 1.2;">
          <a class="has-text-white" @click.prevent="group.type == 'A' ? toDetailPost(post, 'classes') : toDetailPost(post, 'groups')">{{ post.title }}</a>
        </h3>
      </div>

      <div class="column is-narrow has-text-centered" v-if="['M'].indexOf(post.group.groupMemberRole) > -1">
        <button class="button is-medium is-white is-boxed-2" style="margin-bottom: 10px;" @click.prevent="group.type == 'A' ? toDetailPost(post, 'classes') : toDetailPost(post, 'groups')">
          <i class="fa fa-upload"></i>
        </button>
        <p class="has-text-white">Kumpulkan Tugas</p>
      </div>
      <div class="column is-narrow has-text-centered" v-else-if="['O', 'A'].indexOf(post.group.groupMemberRole) > -1">
        <button class="button is-medium is-white is-boxed-2" style="margin-bottom: 10px;" @click.prevent="group.type == 'A' ? toDetailPost(post, 'classes') : toDetailPost(post, 'groups')">
          <i class="fa fa-list-ol"></i>
        </button>
        <p class="has-text-white">Lihat Hasil</p>
      </div>
    </div>

    <div v-else-if="post.type == 'V'" style="margin-bottom: 10px;">
      <div class="box is-bg-success has-text-centered is-no-box-shadow" v-if="post.zoomStatus == 'ended'" style="margin: 0 -13px; border-radius: 0; padding: 10px; border: none;">
        <p style="margin: 0;" class="has-text-white"><i class="fas fa-check"></i>&nbsp;Pertemuan telah selesai</p>
      </div>
      <div v-else>
        <a v-if="['O', 'A'].indexOf(post.group.groupMemberRole) > -1 && (isEmpty(post.zoomStatus) || post.zoomStatus == 'waiting')" @click.prevent="startMeeting" target="_blank" rel="noopener" class="button is-fullwidth is-large is-info has-text-white" :class="{'is-loading': loading_start_meeting}" :disabled="loading_start_meeting">
          <span class="icon">
            <i class="fas fa-chalkboard"></i>
          </span>
          <span><small>Mulai Conference</small></span>
        </a>
        <a v-else-if="['O', 'A'].indexOf(post.group.groupMemberRole) > -1 && (post.zoomStatus == 'started')" @click.prevent="startMeeting" target="_blank" rel="noopener" class="button is-fullwidth is-large is-info has-text-white" :class="{'is-loading': loading_start_meeting}" :disabled="loading_start_meeting">
          <span class="icon">
            <i class="fas fa-chalkboard"></i>
          </span>
          <span><small>Gabung ke Conference</small></span>
        </a>
        <div class="box is-bg-lighterblue has-text-centered" v-else-if="['M'].indexOf(post.group.groupMemberRole) > -1 && (isEmpty(post.zoomStatus) || post.zoomStatus == 'waiting')">
          <p style="margin: 0;"><i class="fas fa-spinner"></i>&nbsp;Pertemuan belum dimulai</p>
        </div>
        <a v-else-if="['M'].indexOf(post.group.groupMemberRole) > -1 && post.zoomStatus == 'started'" :href="group.type == 'A' ? `${post.zoomJoinUrl} + &uname=${account.name}|${account.userUniversityId}|${group.groupMemberId}` : `${post.zoomJoinUrl} + &uname=${auth.name}||${group.groupMemberId}`" target="_blank" rel="noopener" class="button is-fullwidth is-large is-bg-info has-text-white">
          <span class="icon">
            <i class="fas fa-chalkboard"></i>
          </span>
          <span><small>Gabung ke Conference</small></span>
        </a>
        <div class="box is-bg-success has-text-centered" v-else-if="post.zoomStatus == 'ended'">
          <p><i class="fas fa-check"></i>&nbsp;SELESAI</p>
        </div>
        <br v-if="!isEmpty(post.zoomStatus) && post.zoomStatus == 'started' && post.group.groupMemberRole == 'M'">

        <div v-if="!isEmpty(post.zoomStatus) && post.zoomStatus == 'started'">
          <b-field label="ID" v-if="post.group.groupMemberRole == 'M'">
            <b-input expanded :value="post.zoomMeetingId" readonly></b-input>
          </b-field>

          <b-field label="Password" v-if="post.group.groupMemberRole == 'M'">
            <b-input type="password" expanded :value="post.zoomPassword" readonly password-reveal></b-input>
          </b-field>

          <b-field label="Your Name" v-if="post.group.groupMemberRole == 'M'">
            <b-input expanded :value="`${account .name}|${account.userUniversityId}|${post.group.groupMemberId}`" readonly></b-input>
          </b-field>

          <p class="help has-text-grey" v-if="post.group.groupMemberRole == 'M'"><small>Untuk pencatatan tanda kehadiran, pastikan kolom <code>"Your Name"</code> pada ZOOM sesuai dengan kolom diatas.</small></p>
        </div>
      </div>
    </div>

    <div v-if="!isEmpty(image_video_medias)">
      <br>
      <custom-carousel
        style="margin: 0 -13px 12px;"
        :items="image_video_medias"
        :onPlaying="onVideoPlaying" :onPaused="onPausedVideo" :onBuffer="onVideoBuffer" :onEnded="onEndedVideo"
      ></custom-carousel>
    </div>

    <div v-show="!isEmpty(file_medias) && show_attachment_list" class="">
      <div v-for="(media, key) in file_medias" :key="key">
        <div class="columns is-mobile is-gapless is-vcentered">
          <div class="column is-narrow tooltip" data-tooltip="Download" @click.prevent="downloadPostMedia(media)">
            <button class="button is-small"><span class="icon"><i class="fas fa-download"></i></span></button>
          </div>
          <div class="column truncated-text">
            <div class="columns is-mobile is-vcentered is-gapless">
              <div class="column is-narrow">
                <button class="button is-text tooltip" data-tooltip="Preview" @click.prevent="selectMedia(media)">
                  <span class="icon">
                    <icon-collection :media="media" size="is-16x16"></icon-collection>
                  </span>
                </button>
              </div>
              <div class="column">
                <span><small>{{ media.name }}</small></span>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="columns is-vcentered is-mobile" style="margin-bottom: 0;">
      <div class="column">
        <social-sharing :url="getDetailUrl(post, 'groups')"
          @open="onSharingPopupOpened"
          @close="onSharingPopupClosed"
          :title="post.title"
          :description="shareableDescription(post)"
          :quote="!isEmpty(post.excerpt) ? post.excerpt : post.cleanDescription"
          inline-template>
          <div>
            <b-dropdown hoverable aria-role="list">
              <a href="" @click.prevent="" slot="trigger" class="has-text-grey" style="font-size: 13px;">
                <span class="icon">
                  <i class="fas fa-share"></i>
                </span>
                <span clas>Bagikan</span>
              </a>

              <b-dropdown-item aria-role="listitem" style="color: #3b5998">
                <network network="facebook">
                  <i class="fab fa-facebook"></i> Facebook
                </network>
              </b-dropdown-item>

              <b-dropdown-item aria-role="listitem" style="color: #0e76a8">
                <network network="linkedin">
                  <i class="fab fa-linkedin"></i> LinkedIn
                </network>
              </b-dropdown-item>

              <b-dropdown-item aria-role="listitem" style="color: #38A1F3">
                <network network="twitter">
                  <i class="fab fa-twitter"></i> Twitter
                </network>
              </b-dropdown-item>

              <b-dropdown-item aria-role="listitem" style="color: #25D366">
                <network network="whatsapp">
                  <i class="fab fa-whatsapp"></i> Whatsapp
                </network>
              </b-dropdown-item>

              <b-dropdown-item aria-role="listitem" style="color: #4995BE">
                <network network="telegram">
                  <i class="fab fa-telegram"></i> Telegram
                </network>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </social-sharing>
      </div>
      <div class="column">
        <div class="has-text-right" style="font-size: 13px;">
          <a v-if="file_medias.length > 0" href="" class="has-text-grey" @click.prevent="show_attachment_list = !show_attachment_list">
            <i class="fa fa-paperclip"></i>&nbsp; {{ file_medias.length }} Lampiran&nbsp;&nbsp;&nbsp;
          </a>
          <a href="" @click.prevent="" class="has-text-grey">{{ counted_comments }} Komentar</a>
        </div>
      </div>
    </div>

    <hr style="margin: 0 -13px 10px;">

    <comment-box @onReplied="(data) => post.commentCount = data.dataProvider.page.total" :group="group" :post="post" :commentsData="post.comments" :memberId="post.group.groupMemberId"></comment-box>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { POST, QUIZ, LEARNING_MATERIAL } from '~/consts';
import SHARE from '~/mixins/share';
import POST_MIXINS from '~/mixins/post';
import Countdown from '~/components/Countdown';

export default {
  components: {
    'vcountdown': Countdown
  },

  mixins: [SHARE, POST_MIXINS],

  props: {
    group: {
      type: Object,
      required: true
    },
    post: {
      type: Object,
      required: true
    },
    afterSave: {
      type: Function,
      required: false
    },
    afterReply: {
      type: Function,
      default: () => {}
    },
    showCommentLists: {
      type: Boolean,
      default: () => false
    },
    selectMedia: {
      type: Function,
      default: () => {}
    },
    setPosts: {
      type: Function,
      default: () => {}
    },
    setPostsDataProvider: {
      type: Function,
      default: () => {}
    },
    embed: {
      type: Boolean,
      default: false
    },
    editPost: {
      type: Function,
      default: () => {}
    },
  },

  computed: {
    ...mapState({
      auth: state => state.auth,
      account: state => state.auth.active_pt,
      loading_start_quiz: state => state.quizes.loading_start_quiz
    }),
    counted_comments() {
      return this.post.commentCount
    },
    medias() {
      let youtubes = [];

      if (!this.isEmpty(this.post.youtube) && !this.isEmpty(this.post.youtube.ids)) {
        youtubes = collect(_.cloneDeep(this.post.youtube.urls)).map((item, key) => {
          return {
            extension: 'youtube',
            link: this.post.youtube.urls[key],
            mime: 'text/plain',
            name: '',
            ref: {
              youtubeId: this.post.youtube.ids[key]
            },
            type: 'youtube'
          }
        }).toArray()
      }

      return collect(this.post.medias).merge(youtubes).toArray()
    },
    image_video_medias() {
      const vm = this;
      const post = this.post;

      if (!this.isEmpty(post) && !this.isEmpty(this.medias)) {
        return collect(this.medias).filter((media) => {
          return media.type == 'video' || media.type == 'youtube' || media.type == 'image';
        }).map((media) => {
          if (media.type == 'image') {
            return {
              type: media.type,
              link_source: !vm.isEmpty(media.images) && !vm.isEmpty(media.images.original) && !vm.isEmpty(media.images.original.link) ? media.images.original.link : '',
              link_thumb: !vm.isEmpty(media.images) && !vm.isEmpty(media.images.original) && !vm.isEmpty(media.images.original.link) ? media.images.original.link : ''
            }
          } else if (media.type == 'youtube') {
            return {
              type: media.type,
              link_source: media.link,
              youtubeId: media.ref.youtubeId
            }
          } else if (media.type == 'video') {
            return {
              type: media.type,
              link_source: media.file.link,
            }
          }
        }).toArray();
      }

      return [];
    },
    file_medias() {
      const vm = this;
      const post = this.post;

      if (!this.isEmpty(post) && !this.isEmpty(this.medias)) {
        return collect(this.medias).filter((media) => {
          return media.type == 'document';
        }).toArray();
      }

      return [];
    },
    author() {
      const post = this.post;
      const user = post.user;
      const uu = post.universityUser;
      const avatar_url = !this.isEmpty(user) && !this.isEmpty(user.media) && !this.isEmpty(user.media.images)
        ? user.media.images.thumb.link : null;

      if (this.group.type === 'A' && !this.isEmpty(uu)) {
        return {
          name: uu.name,
          username: uu.username,
          gender: uu.gender,
          role: !this.isEmpty(uu.type) ? uu.type[0] : '',
          avatar_url
        }
      }

      return {
        name: user.name,
        username: user.username,
        gender: user.gender,
        role: '',
        avatar_url
      };
    },
  },

  mounted() {
    $('.dropdown').mouseenter(function () {
      $(this).addClass('is-active');
    }).mouseleave(function () {
      $(this).removeClass('is-active');
    });

    window.addEventListener("scroll", this.onScroll)
  },

  watch: {
    is_visible(val) {
      const vm = this;

      if (val) {
        if (vm.isEmpty(vm.view_interval)) {
          vm.view_interval = setInterval(function () {
            vm.view_timer = vm.view_timer + 1;
          }, 1000)
        }
      } else {
        clearInterval(vm.view_interval)
        vm.view_interval = null
        vm.view_timer = 0
      }
    },
    view_timer(val) {
      if (val == this.time_to_track_post) {
        if (['P', 'G', '0'].indexOf(this.post.group.type) > -1) {
          // this.track('post', 'view_post', this.post.id)
        } else {
          // this.track('post', 'view_post', this.post.id, 'gm', this.post.group.groupMemberId)
        }
      }
    }
  },

  data() {
    const truncate_limit = 300;
    const truncate_act_limit = 30;

    return {
      view_timer: 0,
      view_interval: null,
      is_visible: false,
      truncate_limit,
      truncate_act_limit,
      is_truncate: !this.isEmpty(this.post.cleanDescription) && this.post.cleanDescription.length > truncate_limit,
      is_truncate_act: this.getActDesc(this.post).length > truncate_act_limit,
      loading_store_response: false,
      show_attachment_list: true,
      loading_start_meeting: false
    }
  },

  methods: {
    ...mapActions({
      destroyPost: 'posts/destroy',
      playQuiz: 'quizes/startQuiz'
    }),
    seeMore(post) {
      this.is_truncate = false

      this.track('post', 'post_clicked_see_more', post.id)
    },
    async downloadPostMedia(media) {
      await this.download(media, this.post.groupId);

      this.track('post', 'download_media', this.post.id, 'gm', this.post.group.groupMemberId, {
        media_id: media.id
      })
    },
    onDeletedPost(data) {
      const vm = this;
      if (data.applicationSystem.code == 0) {
        vm.setPosts(data.data.data);
        vm.setPostsDataProvider(data.data.dataProvider);

        toast.success(data.applicationSystem.message);
      } else {
        toast.danger(data.applicationSystem.message);
      }

      vm.loading = false;
    },
    onScroll(e) {
      const rect = this.$el.getBoundingClientRect();
      let viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
      this.is_visible = !(rect.bottom < 0 || rect.top - viewHeight >= 0);
    },
    getDetailUrl(post, group_type) {
      const vm = this;
      let host = process.server ? this.$store.app.context.req.headers.host : window.location.host

      if (post.group.type == 'G') {
        return post.extUrl;
      } else if (post.group.type == 'U') {
        return host + `/panel/university/news/${post.id}`
      } else if (!vm.isEmpty(post.section) && ['M', 'Z', 'Q', 'V'].indexOf(post.type) > -1) {
        return host + `/panel/${group_type}/${vm.group.id}/sections/${post.section.id}/${post.id}`
      } else {
        return host + `/panel/${group_type}/${vm.group.id}/${post.id}`
      }
    },
    startQuiz(id) {
      this.playQuiz(id);
    },
    toDetailPost(post, group_type) {
      const vm = this;

      if (this.embed) {
        if (!vm.isEmpty(post.section) && ['M', 'Z', 'Q', 'V'].indexOf(post.type) > -1) {
          vm.$router.push({ path: `/embed/classes/${vm.group.kelasId}/materials/${post.id}`, query: { t: this.$store.state.token } })
        }
      } else {
        if (post.group.type == 'G') {
          window.open(post.extUrl, '_blank');
        } else if (post.group.type == 'U') {
          vm.$router.push({ path: `/panel/university/news/${post.id}` })
        } else if (!vm.isEmpty(post.section) && ['M', 'Z', 'Q', 'V'].indexOf(post.type) > -1) {
          vm.$router.push({ path: `/panel/${group_type}/${vm.group.id}/sections/${post.section.id}/${post.id}` })
        } else {
          vm.$router.push({ path: `/panel/${group_type}/${vm.group.id}/${post.id}` })
        }
      }
    },
    autoresize() {
      let el = this.$refs.comment_col;
      let css = 'background-color: #F7F7F7; display: block; overflow: hidden;';

      el.style.cssText = `${css} height:` + el.scrollHeight + `px`;
    },
    edit(post) {
      if (['I', 'E', 'S'].indexOf(post.type) > -1) {
        this.editPost(post)
      } else {
        this.toDetailPost(post, this.group.type == 'A' ? 'classes' : 'groups')
      }
    },
    checkCapabilities() {
      if (this.group.memberRole == 'GUEST') {
        toast.error('Akses anda dibatasi, gabung ke grup terlebih dahulu');

        throw new Error('Akses anda dibatasi, gabung ke grup terlebih dahulu');
      }
    },
    addChoice(survey, choice, choice_key) {
      const vm = this;

      this.checkCapabilities();

//    Prevent brute force
      if (vm.loading_store_response) {
        return;
      }

      const postData = {
        surveyType: survey.surveyType,
        choiceId: choice.id,
        isChecked: choice.selected ? 0 : 1 // reverse from selected
      };

      if (vm.group.type === 'A') {
        postData['university_user_id'] = vm.account.id;
      }

      vm.loading_store_response = true;

      this.$axios.post(POST.ADD_SURVEY_RESPONSE(vm.group.id, survey.id), postData)
        .then(({ data }) => {
          if (data.applicationSystem.code == 0) {
            vm.post.survey['choices'] = data.data;

            Vue.nextTick(() => {
              vm.loading_store_response = false;
            });
          } else {
            toast.danger(data.applicationSystem.message);
          }
        }).catch(() => {
          vm.loading_store_response = false;
          toast.danger('Terjadi kesalahan pada sistem');
        });
    },
    capitalize(text) {
      return helpers.capitalize(text);
    },
    getDay(date) {
      return moment(date).format('D');
    },
    getMonth(date) {
      date = moment(date).format('MMM');
      return this.capitalize(date);
    },
    getYear(date) {
      return moment(date).format('YYYY');
    },
    getFormattedDate(date) {
      date = moment(date);
      return `${this.capitalize(date.format('dddd'))}, ${this.capitalize(date.format('Do'))} ${this.capitalize(date.format("MMMM YYYY, HH:mm"))}`;
    },
    roundNumeric(float) {
      return !isNaN(float) ? parseFloat(Math.round(float * 100) / 100) : 0;
    },
    isEmpty(item) {
      return helpers.isEmpty(item);
    },
    isImage(media) {
      return !this.isEmpty(media.mime) ? media.mime.split('/')[0] == 'image' : false;
    },
    detailComment(comment, attribute) {
      const post = this.post;
      const user = comment.user;
      const uu = comment.universityUser;

      if (this.group.type === 'A' && uu !== null && uu !== undefined) {
        return comment.universityUser[attribute];
      }

      return comment.user[attribute];
    },
    startMeeting() {
      const vm = this;

      if (vm.loading_start_meeting) {
        return;
      }

      vm.loading_start_meeting = true

      this.$axios.post(LEARNING_MATERIAL.START_MEETING, {
        id: this.post.id
      }).then(({ data }) => {
        if (data.applicationSystem.code == 0) {
          window.open(data.data.startUrl, '_blank');
        } else {
          toast.danger(data.applicationSystem.message);
        }

        vm.loading_start_meeting = false
      }).catch(() => {
        vm.loading_start_meeting = false
      })
    },
    onSharingPopupOpened() {

    },
    onSharingPopupClosed() {
      this.track('post', 'share_post', this.post.id)
    },
    onPausedVideo(e, duration) {
      if (['M'].indexOf(this.post.group.groupMemberRole) > -1) {
        this.onVideoPaused(e, duration, this.post.id, this.post.group.groupMemberId);
      }
    },
    onEndedVideo(e, duration) {
      if (['M'].indexOf(this.post.group.groupMemberRole) > -1) {
        this.onVideoEnded(e, duration, this.post.id, this.post.group.groupMemberId);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  margin-bottom: 10px !important;

  pre {
    ul {
      background: #ebebeb;
      font-style: italic;
      padding: 20px 40px;
    }

    ul, figure.image, .content figure {
      margin-left: 0;
      margin-right: 0;
      width: auto !important;
    }

    figure.image figcaption {
      color: #8a8a8a;
    }
  }
}

.comment {
  padding: 8px;
  background-color: #fafafa;
  border: 1px solid #E5E5E5;
  margin-top: 7px;
  border-radius: 3px;
}

.pre-comment {
  background: none;
  padding: 0 !important;
  font-family: inherit;
  white-space: pre-line !important;
}
</style>
